import styled from 'styled-components'

export default (styled.div || styled.View)`
  padding: 0 25px 25px;
`
